<template>
    <div class="button-container" @click="$emit('click', $event)">
        <Clickable>
            <StatusIcon status="false"></StatusIcon>
        </Clickable>
    </div>
</template>

<script>
    import Clickable from './Clickable.vue';
    import StatusIcon from './StatusIcon.vue';

    export default {
        data() {
            return {};
        },
        components: {
            Clickable,
            StatusIcon
        }
    }
</script>

<style scoped lang="scss">
    .button-container {
        width: 100%;
        height: 100%;
        color: $falseColor;
    }
</style>